import React, {Component} from 'react'
import {Button, Header, Modal, Input} from 'semantic-ui-react'

export default class RegisterRegularPlayerModal extends Component {

    state = {
        name: ""
    };

    changeName = (ev, data) => this.setState({name: data.value});

    handleSubmit = () => this.props.registerRegularPlayer(this.state.name);

    render() {
                return (
            <Modal
                open={this.props.open}
                basic
                size='small'
                closeOnEscape={true}
                closeOnDimmerClick={true}
            >
                <Header icon='users' content='Hvem skal avregistreres?'/>
                <Modal.Content>
                    <Input placeholder='navn' onChange={this.changeName} value={this.state.name}/>
                </Modal.Content>
                {this.state.name ?
                    <Modal.Actions>
                        Registrere {this.state.name}?
                        {<Button inverted onClick={this.handleSubmit} color='green' content='Stemmer'/>}
                    </Modal.Actions>
                    : <Modal.Actions>
                        Hvem skal registreres?
                    </Modal.Actions>}
            </Modal>)
    }
}



// WEBPACK FOOTER //
// ./src/Components/RegisterRegularPlayerModal.js